<template>
  <div class="ourteam-box">
    <div class="text-box">
      <div class="title-box">
        <div class="en-title">TEAM</div>
        <div class="cn-title">我们的团队</div>
      </div>
      <div class="text">
        <p>山木枝信息技术有限公司是一个致力于技术和商业相融合的创意团队。</p>
        <p>专注于用户体验设计与品牌数字革新的解决方案。</p>
        <p>
          富含正能量的一群不拘泥于传统，爱思考的我们坚信正派与务实的经营之道让我们走得更远。
        </p>
      </div>
    </div>
    <img class="banner" src="@/assets/team/banner.png"></img>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url('./index.scss');
</style>
